import type { AccountCampaign } from '../../types/accountCampaign';
import type { Campaign } from '../../types/campaign';

// Resolve the human-visible Campaign name for a row (Pre-P2b-3 §4.2):
//
//   campaignNameOverride if set
//   else underlying Campaign.name
//   else "— No Campaign —" when the row is unassigned
//
// Pure helper used by the master grid Campaign cell and the row
// editor's Overview. The underlying campaignId still drives selection
// state (the dropdown is bound to it); the override only changes the
// label the AM sees.

export function resolveDisplayCampaignName(
  row: Pick<AccountCampaign, 'campaignNameOverride' | 'rowType'>,
  campaign: Pick<Campaign, 'name'> | null | undefined,
): string {
  const override = row.campaignNameOverride;
  if (typeof override === 'string' && override.length > 0) return override;
  if (campaign?.name) return campaign.name;
  if (row.rowType === 'unassigned') return '— No Campaign —';
  return '(unknown campaign)';
}
